import React, {useState} from 'react';
import {IObjectSelectProps} from '../ObjectSelect';
import {IClassNameProps, withBemMod} from '@bem-react/core';
import {cnObjectSelect} from '../index';
import {useTranslation} from "react-i18next";
import {ITabletopData} from '../../../../../common-code/interfaces/materials/ITabletopData';
import {ObjectSelectSelect} from '../Select/ObjectSelect-Select';
import {OBJECT_SELECT_TYPE_TABLETOP} from '../../../../constants';
import {Modal} from '../../Modal';
import {AccessoryList, cnAccessoryList} from '../../../elements/AccessoryList/AccessoryList';

const ObjectSelectTabletop: React.FC<IObjectSelectProps<ITabletopData>> =
    ({
         data,
         list,
         title,
         onSelectObject,
         onChangeDepth,
         showObject,
         className,
         facadeMaterials
     }) => {
        const {t} = useTranslation();

        const emptyObjectData: ITabletopData = {
            id: 'none',
            title: t('Не выбрано'),
            materialType: 'none',
            height: 0,
            depth: 0,
            image: ''
        };
        const objectData: ITabletopData = data && data.object ? data.object : emptyObjectData;
        const [showModal, setShowModal] = useState<boolean>(false);

        return (
            <div className={cnObjectSelect({}, [className])}>
                <ObjectSelectSelect
                    className={cnObjectSelect('Select')}
                    image={showObject && objectData.image ? {path: objectData.image, label: objectData.title, width: 60, height: 60} : undefined}
                    color={showObject && !objectData.image && objectData.color ? {path: objectData.color, label: objectData.title, width: 60, height: 60} : undefined}
                    icon={!showObject || (!objectData.image && !objectData.color) ? {path: 'no-photo', label: objectData.title, width: 60, height: 60} : undefined}
                    title={title}
                    description={showObject ? objectData.title : t('Не выбрано') || undefined}
                    callBack={() => {
                        setShowModal(true);
                    }}
                />
                {showModal ?
                    <Modal
                        className={cnObjectSelect('Modal')}
                        visible={showModal}
                        callBack={setShowModal}
                        size={'full'}
                    >
                        {!list || !onSelectObject ?
                            <div className={cnObjectSelect('Error')}>{t('Загрузка данных')}...</div> :
                            <AccessoryList
                                className={cnObjectSelect(cnAccessoryList())}
                                listMaterialData={list}
                                materialData={objectData}
                                onSelectObject={onSelectObject}
                                onChangeDepth={onChangeDepth}
                                showObject={showObject}
                                title={title}
                                facadeMaterials={facadeMaterials}
                                setShowModal={setShowModal}
                            />
                        }
                    </Modal> : null
                }
            </div>
        );
    }

export const withObjectSelectTabletop = withBemMod<IObjectSelectProps<ITabletopData>, IClassNameProps>(
    cnObjectSelect(),
        { type: OBJECT_SELECT_TYPE_TABLETOP },
        () => ObjectSelectTabletop
);